import Vue from 'vue'
import App from './App.vue'
import vfmPlugin from 'vue-final-modal'

Vue.config.productionTip = false
Vue.use(vfmPlugin)

new Vue({
  render: h => h(App),
}).$mount('#app')
